export class ReportEditionListItem {
    reportEditionId: string;
    fromDate: Date;
    toDate: Date;
    publicationDate: Date;

    constructor(reportEditionId: string, fromDate: Date, toDate: Date, publicationDate: Date) {
        this.reportEditionId = reportEditionId;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.publicationDate = publicationDate;
    }
}
